import shapes from 'assets/shapes-bg.png';

import styled from '@emotion/styled';
import { css } from '@emotion/react';
// @mui
import MuiContainer from '@mui/material/Container';
// @ld
import { colors } from '@ld/utils';
// @custom

export const Container = styled(MuiContainer)`
  && {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
`;

export const AppMain = styled.main`
  min-height: 100vh;
  padding: 40px 40px 40px 280px;
  background-color: ${colors.grey5};

  ${(props) => props.theme.breakpoints.down('md')} {
    margin: 0;
    padding: 16px;
  }
`;

type MainProps = {
  $isCentered?: boolean;
};

export const Main = styled.main<MainProps>`
  flex: 1;
  width: 100%;
  position: relative;
  ${(props) =>
    props.$isCentered &&
    css`
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    `}
`;

export const MainWithAppBar = styled.main`
  flex: 1;
  position: relative;
  padding-top: 140px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    padding-top: 40px;
  }
`;

export const ShapesBackground = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: url(${shapes});
  background-size: contain;
`;

export const AuthContainer = styled.div`
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const Card = styled.div`
  background: #ffffff;
  box-shadow: 0px 20px 60px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  width: 380px;
  max-width: 90%;
  /* padding: 30px; */
  z-index: 2;
  margin-top: 16px;

  ${(props) => props.theme.breakpoints.down('xs')} {
    width: 100%;
  }
`;

export const AuthMain = styled.div`
  min-height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: row;
  z-index: 2;
`;

export const AuthValueContainer = styled.div`
  width: 100%;
  margin-top: 24vh;
  margin-left: 10.4vw;
  @media (min-width: 320px) and (max-width: 1080px) {
    display: none;
  }
`;

export const AuthChildrenContainer = styled.div`
  background: #fff;
  z-index: 2;
  height: 100vh;
  display: flex;
  flex-direction: column;
  @media (min-width: 320px) and (max-width: 1080px) {
    width: 100vw;
  }
  @media (min-width: 1081px) {
    width: 35vw;
  }
`;

export const AuthChildren = styled.div`
  flex: 1;
  margin-top: 14%;
`;
export const ValueDisplay = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ValueDisplayWithoutIcon = styled.div`
  width: 29.06vw;
`;
